import Vue from 'vue';
import Vuex, { MutationTree } from 'vuex';

import authStore from './authStore';
import ticketsStore from './ticketsStore';
import { RootState } from './index.d';

Vue.use(Vuex);

const rootState: RootState = {
  appIsLoading: false,
  flashMessage: {
    level: 'normal',
    message: null,
  },
};

const mutations: MutationTree<RootState> = {
  setLoadingState(state, loadingState) {
    state.appIsLoading = loadingState;
  },

  setFlashMessage(state, payload) {
    const [message, level]: Array<string|undefined> = payload;

    state.flashMessage.message = typeof message !== 'undefined' ? message : null;
    state.flashMessage.level = typeof level !== 'undefined' ? level : 'normal';
  },
};

export default new Vuex.Store({
  state: rootState,
  mutations,
  actions: {
  },
  getters: {
    flashMessage(state) {
      return state.flashMessage;
    },
  },
  modules: {
    auth: authStore,
    tickets: ticketsStore,
  },
});
